module.exports = __webpack_public_path__ + "img/star.9359dc2a.png";